module.exports = require('lodash').forEach